import { render, staticRenderFns } from "./IntegracoesApiItajai.vue?vue&type=template&id=a05f76b4&scoped=true"
import script from "./IntegracoesApiItajai.vue?vue&type=script&lang=js"
export * from "./IntegracoesApiItajai.vue?vue&type=script&lang=js"
import style0 from "./IntegracoesApiItajai.vue?vue&type=style&index=0&id=a05f76b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05f76b4",
  null
  
)

export default component.exports